import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from "@angular/router";
import { OAuthService } from "../../shared/services/authorization/oauth.service";
import { tap } from "rxjs/operators";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private authorizationService: OAuthService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // if the request has this special header, it shouldn't be modified
    if(request.headers.has('Skip-Interceptor')) {
      const newHeaders = request.headers.delete('Skip-Interceptor')
      const newRequest = request.clone({ headers: newHeaders });
      return next.handle(newRequest);
    }

    const tokenResponse = JSON.parse(localStorage.getItem('authorization.service.token_response') || '{}');
    const token = tokenResponse ? tokenResponse.access_token : null;

    if (token) {
      let updateOptions = {};
      if (request.responseType === 'blob') {
        updateOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
            'Accept': 'application/pdf',
            'Content-Type': 'application/json'
          })
        }
      } else {
        updateOptions = {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
            Accept: 'application/json'
          })
        }
      }
      const requestWithAuthHeader = request.clone(updateOptions);

      return next.handle(requestWithAuthHeader).pipe(tap((event: HttpEvent<any>) => { },
        (err: any) => {
          return this.handleAuthError(err);
        })
      );
    } else {
      return next.handle(request).pipe(tap((event: HttpEvent<any>) => { },
        (err: any) => {
          return this.handleAuthError(err);
        })
      );
    }
  }
  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow

    if (err.status === 403 || err.status === 401) {
      this.authorizationService.emptySessionStorage();
      this.router.navigateByUrl(`/404`);
      // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
      return Observable.create(err.message)
    }
    return throwError(err);
  }
}